import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=18ed4cbf&"
import script from "./tree.vue?vue&type=script&lang=ts&"
export * from "./tree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Thermotech\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18ed4cbf')) {
      api.createRecord('18ed4cbf', component.options)
    } else {
      api.reload('18ed4cbf', component.options)
    }
    module.hot.accept("./tree.vue?vue&type=template&id=18ed4cbf&", function () {
      api.rerender('18ed4cbf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Dev/js/components/products/tree/tree.vue"
export default component.exports